<div class="mb-3 col-md-3 ml-md-auto">
    <!-- <a routerLink="/confrmTecList" class="btn btn-outline-success btn-sm" role="button" aria-pressed="true">View Confirm
        List</a> -->

</div>
<div class="card mb-4">
    <div class="card-body">
        <div *ngIf="showTable; else formView">
            <div class="mb-4 d-md-flex align-items-center justify-content-between">
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-10">
                            <h3 class="text-center font-bold font-up danger-text">Pending Order List</h3>
                        </div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="orderList.length > 0; else noData">
                <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3"><i class="feather icon-trash-2"></i></button>
            <div class="table-responsive">
                <table class="table mb-0 table-centered table-bordered">
                    <thead>
                        <tr>
                            <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
                            <th>Ticket No</th>
                            <th>Ref No</th>
                            <th>PO No</th>
                            <th>Client Name</th>
                            <th>Job Name</th>
                            <th>Job Type</th>
                            <th>Order Kgs</th>
                            <th>FD Option</th>
                            <th>Status</th>
                            <!-- <th>Action</th> -->
                        </tr>
                    </thead>
  
                    <!-- Add *ngFor loop for displaying user data -->
                    <tbody>
                        <tr *ngFor="let order of orderList">
                            <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="order._id"></td>
                            <td>{{ order.ticketno }}</td>
                            <td>{{ order.refNo }}</td>
                            <td>{{ order.poNo }}</td>
                            <td>{{ order.clientName}}</td>
                            <td>{{ order.jobName }}</td>
                            <td>{{ order.jobType }}</td>
                            <td>{{ order.orderKgs | number:'1.2-2':'en-US'}}</td>
                            <td>{{ order.fdOption }}</td>
                            <td>
                                <button 
                                     class="btn btn-outline-success btn-sm"
                                    title="Click to Confirm order"
                                    (click)="openReconfirmationForm(order)"
                                    >Pending
                            </button>
                            </td>
                            <!-- <td>
                                <button type="button" class="btn btn-outline-success btn-sm"
                                 (click)="saveOrder()" 
                                 [routerLink]="['/editorderList', order._id]"> 
                                 <i class="feather icon-edit "></i>Edit
                                </button>
                                
                            </td> -->
                  
                        </tr>
                    </tbody>
                </table><!--end /table (click)="saveOrder()"  routerLink="/UnsavedOrder/{{order._id}}" --> 
            </div><!--end /tableresponsive-->
            </ng-container>
            <ng-template #noData>
                
                    <div class="alert alert-warning" role="alert">
                        There is no data available.
                    </div>
                
            </ng-template>
            <div class="pagination-container">
              <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                <div>
                  <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems }}</p>
                </div>
  
                <div class="d-flex">
                  <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                    <i class="feather icon-chevrons-left"></i>
                  </a>
                
                  <ng-container *ngFor="let page of getNumberRange(ceil(totalItems / itemsPerPage))">
                    <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                      {{ page }}
                    </a>
                    <span *ngIf="page < ceil(totalItems / itemsPerPage)" class="page-number-space"></span>
                  </ng-container>
                
                  <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceil(totalItems / itemsPerPage)}">
                    <i class="feather icon-chevrons-right"></i>
                  </a>
                </div>
  
              </div>
            </div>
          </div>
        
  
          <ng-template #formView>
            <div class="mb-4 d-md-flex align-items-center justify-content-between">
        
                <div>
                    <h3>Complete Job info and Save</h3>
                    <p>Kindly check all the information and correct all mistakes and update, then save</p>
                </div>
            </div>
            <div class="form-card">
                <form (ngSubmit)="submitForm()" [formGroup]="editOrderForm">
                    <div class="row">
                        
                        <div class="col form-group mb-3">
                            <label for="clientName" class="form-label">Customer</label>
                            <input type="text"  formControlName="clientName" id="clientName" class="form-control" readonly />
                        </div>
                        
                        <div class="col form-group mb-3">
                            <label for="ticketno" class="form-label">Ticket No.</label>
                            <input type="text" formControlName="ticketno" id="ticketno" class="form-control" readonly/>
                        </div>
                       
                        <div class="col form-group mb-3">
                            <label for="poNo" class="form-label">P.O No	</label>
                            <input type="text" formControlName="poNo" id="poNo" class="form-control"/>
                        </div>
                        <div class="col form-group mb-3">
                            <label for="refNo" class="form-label">RefNo/Code</label>
                            <input type="text" formControlName="refNo" id="refNo" class="form-control" readonly/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group mb-3">
                            <label for="jobName" class="form-label">Job Name</label>
                            <input type="text" formControlName="jobName" id="jobName" class="form-control"/>
                        </div>
                        <div class="col form-group mb-3">
                            <label for="jobType" class="form-label">Job Type</label>
                            <div class="input-group">
                                <select formControlName="jobType" id="jobType" class="form-control minimal">
                                    <option value="Roll Form">Roll Form</option>
                                    <option value="Kgs/Pcs">Kgs/Pcs</option>
                                    <option value="Sleeves">Sleeves</option>
                                    <option value="Labels">Labels</option>
                                </select>
                            </div>
                        </div>
                        <div class="col form-group mb-3">
                            <label for="orderKgs" class="form-label">Order Qty</label>
                            <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control" />
                        </div>
                        <div class="col form-group mb-3">
                            <label for="fdOption" class="form-label">FD Option</label>
                          <div class="input-group"> <select formControlName="fdOption" id="fdOption"
                              class="form-control custom-select minimal">
                              <option value="EMRS">EMRS</option>
                              <option value="EMLS">EMLS</option>
                              <option value="Readable">Readable</option>
                              <option value="Non-Readable">Non-Readable</option>
                              <option value="Any Direction">Any Direction</option>
                              <option value="Direction not Required">Direction not Required</option>
                            </select> </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-end"> 
                        <button type="submit" class="btn btn-primary">Update</button> 
                        <button class="btn btn-secondary ms-2">Cancel</button>
                     </div>
                </form>
            </div>
        </ng-template>
    </div>
  </div>
    


